// extracted by mini-css-extract-plugin
export default {"commentWrapper":"styles_commentWrapper__OlNaI","count":"styles_count__-BTff","icon":"styles_icon__9Ik3T","isUnread":"styles_isUnread__F-ij3"};